<section class="container">
	<div class="sm:py-16 sm:border-y">
		<uc-heading headingTitle="Application Details" />
		<div class="grid items-center sm:grid-cols-2 sm:gap-9">
			<div class="hidden overflow-hidden sm:inline sm:border sm:rounded-lg">
				@if (!clearingCourseEnabled()) {
					<uc-application-deadline
						[applicationDeadline]="applicationDeadline()"
						[externalUrl]="externalUrl()"
						[isFeatured]="isFeatured()"
						[uniId]="uniId()"
						[uniName]="uniName()"
						[product]="product()"
						[courseName]="courseName()"
						[ugSearchOrderPosition]="searchOrder()"
					/>
				}
				@if (clearingCourseEnabled()) {
					<div
						class="flex-col items-center justify-center h-full px-4 py-16 text-center bg-gradient-to-r from-uc-clearing-100 to-uc-blue-900"
					>
						<h3 class="mb-4 text-3xl font-bold leading-10 text-gray-50">
							Apply for Clearing {{ currentClearingYear() }}
						</h3>
						@if (externalUrl() && isFeatured()) {
							<uc-clearing-visit-website-btn
								class="hidden sm:block"
								[externalUrl]="externalUrl()"
								[uniId]="uniId()"
								[uniName]="uniName()"
								[source]="courseName()"
								sourceType="course"
								buttonText="Find out more"
								customStyles="secondary-button"
								sourceType="course"
								componentName="Application Details"
								[cleSearchOrderPosition]="searchOrder()"
								[privacyPolicyUrl]="privacyPolicyUrl()"
							/>
						}
					</div>
				}
			</div>
			<div class="overflow-hidden sm:border sm:rounded-lg">
				<div
					class="hidden grid-cols-2 px-6 py-4 text-sm font-bold tracking-wider text-left uppercase sm:grid-cols-12 sm:grid sm:text-gray-500 sm:bg-gray-50"
				>
					<p class="sm:col-span-7">Provider Details</p>
					<p>Codes/info</p>
				</div>
				<div>
					<uc-course-information-table-row
						providerDetail="Course Code"
						[data]="courseCode()"
					/>
					<uc-course-information-table-row
						providerDetail="Institution Code"
						[data]="institutionCode()"
					/>
					<uc-course-information-table-row
						providerDetail="Points of Entry"
						[entryPoints]="entryPoints()"
						customStyles="border-b sm:border-b-0"
					/>
				</div>
			</div>
		</div>
	</div>
</section>
